import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlIconModule } from '@app/icon-library/lib/pl-icon.module';
import { SharedModule } from '@shared/shared.module';
import { PlTextareaComponent } from '@app/components/pl-textarea/pl-textarea.component';
import { NgsContenteditableModule } from '@ng-stack/contenteditable';
import { FormsModule } from '@angular/forms';
import { IconCustomControlModule } from '@app/components/icon-custom-control/icon-custom-control.module';
import { PlSlicePipeModule } from '@shared/pipes/plSlice/plSlice.pipe.module';

@NgModule({
  imports: [
    CommonModule,
    PlIconModule,
    SharedModule,
    NgsContenteditableModule,
    FormsModule,
    IconCustomControlModule,
    PlSlicePipeModule,
  ],
  declarations: [PlTextareaComponent],
  exports: [PlTextareaComponent],
})
export class PlTextareaModule {}
